export const dataTorrePesadosReducer = (state, action) => {
  const filiais =
    action.payload?.filiais?.map((filial) => ({
      id: filial.id,
      codigo: filial.codigo,
      nome: filial.nome,
    })) || [];

  const transportadoras =
    action.payload?.filiais?.reduce((acc, filial) => {
      const transportadorasWithFilial = filial.transportadoras.map(
        (transp) => ({
          ...transp,
          filialId: filial.id,
          codigoFilial: filial.codigo,
        })
      );
      return [...acc, ...transportadorasWithFilial];
    }, []) || [];

  state.filterOptions = {
    availableFiliais: filiais,
    availableTransportadoras: transportadoras,
  };
};

export const roteirosAlertasReducer = (state, action) => {
  const { payload } = action;
  state.roteirosAlertas.data = payload.roteiros;
  state.roteirosAlertas.isLoading = false;
  state.roteirosAlertas.error = null;
};

export const roteirosCriticidadeReducer = (state, action) => {
  const { payload } = action;
  state.roteirosCriticidade.data = payload.roteiros;
  state.roteirosCriticidade.isLoading = false;
  state.roteirosCriticidade.error = null;
};

export const safraDiaEvolucaoReducer = (state, action) => {
  const { payload } = action;
  state.safraDia.evolucao.data = payload;
  state.safraDia.evolucao.isLoading = false;
  state.safraDia.evolucao.error = null;
};

export const safraDiaPlanejadaReducer = (state, action) => {
  const { payload } = action;
  state.safraDia.planejado.data = payload;
  state.safraDia.planejado.isLoading = false;
  state.safraDia.planejado.error = null;
};
